import React from 'react';
import { FaShieldAlt, FaExclamationTriangle, FaLightbulb, FaBolt } from 'react-icons/fa';
import './SwotMap.css';

// ============================================================
// SWOT DATA — Edit these to update the analysis
// ============================================================
const swotData = {
    strengths: {
        label: 'Strengths',
        icon: <FaShieldAlt />,
        className: 'swot-strengths',
        items: [
            { title: 'is a woman', detail: '' },
            // { title: 'pretty eyes', detail: '' },
            // { title: 'good at math', detail: '' },
            // { title: 'similar values + lifestyle', detail: '' },
            // { title: 'tolerable personality', detail: '' },
            // { title: 'politically aligned', detail: '' },
            // { title: 'not insane', detail: '' },
            // { title: 'sounds like she cares about me??', detail: '' },
            // { title: 'understanding and respectful of time and boundaries', detail: '' },
            // { title: 'knows me well, good foundation', detail: '' },
        ]
    },
    weaknesses: {
        label: 'Weaknesses',
        icon: <FaExclamationTriangle />,
        className: 'swot-weaknesses',
        items: [
            // { title: 'should have more ambition, not competitive enough', detail: '' },
            // { title: 'too quiet + doesnt yap enough', detail: '' },
            // { title: 'unconfident in herself', detail: '' },
            // { title: 'too intertwined with my sis', detail: '' },
            // { title: 'difficult to approach in social settings', detail: '' },
            // { title: 'too short, might be difficult to makeout', detail: '' },
            // { title: 'can be jealous', detail: '' },
            // { title: 'very immature', detail: '' },
            // { title: 'lives a kinda boring life outside of cap?', detail: '' },
            // { title: 'avoids difficult convos', detail: '' },
            // { title: 'manipulative', detail: '' },
            // { title: 'hard to trust', detail: '' },
            // { title: 'egotist (this is ok as long as her ego isnt bigger than mine)', detail: '' },
            // { title: 'attention seeker', detail: '' },
            // { title: 'commitment issues', detail: '' },
            // { title: 'not a cs major, hasn\'t vibe coded, likely ++ngmi & !orz', detail: '' },
            // { title: 'does not share my niche insta feed', detail: '' },
        ]
    },
    opportunities: {
        label: 'Opportunities',
        icon: <FaLightbulb />,
        className: 'swot-opportunities',
        items: [
            // { title: 'fam likes her, opens potential for future, wifey material', detail: '' },
            // { title: 'probably getting into stanford', detail: '' },
            // { title: 'does not / cannot create drama in my life', detail: '' },
        ]
    },
    threats: {
        label: 'Threats',
        icon: <FaBolt />,
        className: 'swot-threats',
        items: [
            // { title: 'age gap + impossible to show her off', detail: '' },
            // { title: 'school timeline is kinda fucked, wont see her for a yr+', detail: '' },
        ]
    }
};

// ============================================================
// COMPONENT
// ============================================================
const SwotMap = () => {
    const quadrants = Object.entries(swotData);

    return (
        <div className="swot-container">
            {/* Gradient background */}
            <div className="swot-header-gradient" />

            <div className="swot-content">
                {/* Hero */}
                <div className="swot-hero">
                    <h1>SWOT Analysis</h1>
                </div>

                {/* SWOT Grid */}
                <div className="swot-grid">
                    {quadrants.map(([key, quadrant]) => (
                        <div key={key} className={`swot-quadrant ${quadrant.className}`}>
                            <div className="swot-quadrant-header">
                                <div className="swot-quadrant-icon">
                                    {quadrant.icon}
                                </div>
                                <h2 className="swot-quadrant-title">{quadrant.label}</h2>
                                <span className="swot-quadrant-count">
                                    {quadrant.items.length} items
                                </span>
                            </div>

                            <div className="swot-items">
                                {quadrant.items.map((item, idx) => (
                                    <div key={idx} className="swot-item">
                                        <div className="swot-item-header">
                                            <div className="swot-item-bullet" />
                                            <span className="swot-item-label">{item.title}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SwotMap;
